import type { AuthMessages, Dictionary } from '../models'

import { LocaleEnum } from '../enums'

const AUTH_MESSAGES_EN: AuthMessages = {
  user: {
    name: 'User',
    email: 'Email',
  },
  password: 'Password',
  keepLoggedIn: 'Keep logged in',
  login: 'Login',
  oidcLogin: 'Login with IAM',
  errors: {
    invalidCredentials:
      'Woops! We cannot let you in with those credentials. Please check them or click on contact support if you have lost your post-it.',
    default: 'An unexpected error ocurred during login. Please try again later or contact support.',
  },
  forgotPassword: 'Forgot your password?',
}

const AUTH_MESSAGES_ES: AuthMessages = {
  user: {
    name: 'Usuario',
    email: 'Correo electrónico',
  },
  password: 'Contraseña',
  keepLoggedIn: 'Mantener sesión iniciada',
  login: 'Entrar',
  oidcLogin: '',
  errors: {
    invalidCredentials:
      '¡Vaya! No podemos dejarte entrar con esas credenciales. Compruébalas o contacta con soporte en caso de haber perdido tu post-it.',
    default:
      'Se produjo un error inesperado durante el inicio de sesión. Vuelve a intentarlo más tarde o ponte en contacto con soporte.',
  },
  forgotPassword: '¿Has olvidado tu contraseña?',
}

export const AUTH_MESSAGES: Dictionary<{ auth: AuthMessages }> = {
  [LocaleEnum.ENGLISH]: {
    auth: AUTH_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    auth: AUTH_MESSAGES_ES,
  },
}
